<div class="card mb-0 mt-0 mine-assessment-wrapper">
  <div class="card-header mine-assessment-header">
    <div class="card-title d-flex flex-column">
      <h6 class="mine-assessment-title">Mine Assessment</h6>
    </div>
  </div>

  <div class="card-body main-stack-vertical mine-assessment-body">
    <div class="top-row-content mine-assessment-content">
      <div class="left-panel">
        <div class="dropdown-wrapper">
          <app-global-dropdown
            [data]="data"
            [scoreData]="statusData"
            (dropdownToggle)="onDropdownToggle($event)"
          >
          </app-global-dropdown>
        </div>
      </div>

      <div class="right-panel">
        <div class="donut-wrapper" [class.dropdown-expanded]="dropdownOpen">
          <div class="chart-center">
            <div class="chart-wrapper" [id]="data.widgetId" [style.height]="data?.chartConfig?.height || '420px'">
            </div>
          </div>

          <div
            class="info-box"
            *ngFor="let mapping of data?.mapping"
            [ngClass]="{'mine-outlook-box': mapping.label === 'Mine Outlook', 'revenue-box': mapping.label === 'Revenue', 'liquidity-runway-box': mapping.label === 'Liquidity runway', 'remaining-mine-life-box': mapping.label === 'Remaining Mine Life'}"
            [ngStyle]="getInfoBoxStyle(mapping.label)"
          >
            <div class="box-header">{{ mapping.label }}</div>
            <ul *ngIf="mapping.infoKeys || mapping.statusKey">
              <li *ngIf="mapping.statusKey && statusData?.[mapping.statusKey]">
                Status : {{ statusData[mapping.statusKey] }}
              </li>

              <ng-container *ngFor="let key of mapping.infoKeys; let i = index">
                <ng-container *ngIf="statusData?.[key]">
                  <!-- Multi-line handling (e.g. Mine Outlook details) -->
                  <ng-container *ngIf="isMultiLine(statusData[key]); else singleLine">
                    <li *ngFor="let line of splitLines(statusData[key]); let first = first">
                      <span *ngIf="first" class="info-label">{{ mapping.description?.[i] }} :</span>
                      {{ line }}
                    </li>
                  </ng-container>

                  <!-- Default single line -->
                  <ng-template #singleLine>
                    <li>
                      <span class="info-label">{{ mapping.description?.[i] }} :</span> 
                      {{ formatInfoBoxValue(mapping.description?.[i], statusData[key]) }}
                    </li>
                  </ng-template>
                </ng-container>
              </ng-container>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
